import React from 'react';
import { Link } from 'react-router-dom';

const SeoOptimization = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-3xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <h1 className="text-4xl font-bold text-brand-blue mb-6 text-center">SEO Optimization</h1>
      <p className="text-lg text-gray-700 mb-6 text-center">
        Boost your website's visibility and attract more organic traffic with our comprehensive SEO services. We use proven strategies to help your business rank higher on search engines and reach your target audience.
      </p>
      <ul className="list-disc pl-6 space-y-3 text-gray-800 mb-8">
        <li>Comprehensive keyword research and strategy</li>
        <li>On-page and off-page SEO optimization</li>
        <li>Technical SEO audits and fixes</li>
        <li>Local SEO for increased regional visibility</li>
        <li>Monthly analytics and performance reporting</li>
      </ul>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default SeoOptimization; 